// Use the service returned by the verified callback, not the provider's brand
// or email: a Google Calendar connection is independent of Google Tasks.
export function mcpDuplicateConnectionMessage(provider: string): string {
  if (['Google Tasks', 'Microsoft To Do', 'Todoist'].includes(provider)) {
    return 'This to-do account already exists in Mango Display. Return to chat to review its task lists. No task-list selections were changed.';
  }
  if (['Google Calendar', 'Outlook Calendar', 'Apple iCloud Calendar'].includes(provider)) {
    return 'This calendar account is already connected to Mango Display. Return to chat to review its calendars. No calendar selections were changed.';
  }
  // Older servers may omit the provider on a duplicate response. Do not guess.
  return 'This account is already connected to Mango Display. Return to chat to review it. No selections were changed.';
}
